import React, { useState } from 'react'
import Navbar from './../Navbar/Navbar';
import Categories from '../Categories/Categories';
import { Filters } from '../../types/filter';

const Header = ({ handleLoading, onChange, filters }: { handleLoading: (loading: boolean) => void, onChange: (value: Filters) => void, filters: Filters }) => {
    const [resetCategories, setResetCategories] = useState(false);

    const handleHomeClick = () => {
        setResetCategories((prev) => !prev); // Toggle state to trigger reset
    };
    return (
        <div>
            <Navbar onChange={onChange} onHomeClick={handleHomeClick} />
            <Categories handleLoading={handleLoading} onChange={onChange} resetTrigger={resetCategories} filters={filters} />
        </div>
    )
}

export default Header